module.exports = __webpack_public_path__ + "static/media/product-6.b49d1b7c.png";